import React, { useEffect, useRef } from "react";
import Select from "react-select";
import "./InputField.css";

const InputField = ({
  label,
  type = "text",
  placeholder,
  value,
  readOnly,
  disabled,
  onChange,
  name,
  options = [],
  required = false,
  max,
  autoFocus ,
  nextRef,
}) => {
  // Support both readOnly and disabled props
  const isDisabled = disabled || readOnly;
  // Custom styles for react-select
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isDisabled ? "#ccc" : "#A26D2B",
      backgroundColor: state.isDisabled ? "#f5f5f5" : provided.backgroundColor,
      boxShadow: state.isFocused ? "0 0 0 1px #A26D2B" : "none",
      "&:hover": { 
        borderColor: state.isDisabled ? "#ccc" : "#A26D2B",
        cursor: state.isDisabled ? "not-allowed" : "pointer"
      },
      minHeight: "40px",
      height: "40px",
      fontSize: "14px",
      opacity: state.isDisabled ? 0.8 : 1,
      cursor: state.isDisabled ? "not-allowed" : "default",
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: "0 8px",
      height: "38px",
      color: state.isDisabled ? "#444" : provided.color,
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      color: state.isDisabled ? "#444" : provided.color,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "#444" : provided.color,
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "38px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the dropdown is on top
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  const handleChange = (e) => {
    onChange(e);
    if (nextRef && e.target.value) {
      nextRef.current?.focus();
    }
  };

  return (
    <div className="input-field-container">
      <div className="select-container">
        {label && <label className="floating-label">{label}</label>}
        {type === "select" ? (
          <Select
            name={name}
            options={options}
            placeholder={placeholder || "Select"}
            isDisabled={isDisabled}
            autoFocus={autoFocus}
            value={value ? options.find((opt) => opt.value === value) : null}
            onChange={(selectedOption) =>
              onChange({
                target: { name, value: selectedOption ? selectedOption.value : "" },
              })
            }
            styles={customStyles}
            menuPortalTarget={document.body}
            isClearable
          />
        ) : type === "file" ? (
          <input
            className="styled-input file-input"
            type="file"
            name={name}
            accept="image/*"
            onChange={onChange}
            required={required}
            disabled={isDisabled}
            autoFocus={autoFocus}
          />
        ) : (
          <input
            className="styled-input"
            type={type}
            name={name}
            placeholder={placeholder}
            value={value}
            readOnly={readOnly}
            disabled={disabled}
            onChange={handleChange}
            required={required}
            max={max}
            autoFocus={autoFocus}
          />
        )}
      </div>
    </div>
  );
};

export default InputField;
